import React from 'react';
import styled from 'styled-components';
import { space, layout, typography, color, position } from 'styled-system';
import Text, { TextProps } from '../text/Text';

export type H2Props = Omit<TextProps, 'tag'> & { tag?: 'h2' };

const StyledH2: React.FC<H2Props> = ({ children, tag, ...otherProps }) => (
    <Text h2 tag="h2" {...otherProps}>
        {children}
    </Text>
);

const H2 = styled(StyledH2)`
    line-height: ${({ theme }) => theme.lineHeights.title};
    ${space}
    ${layout}
  ${typography}
  ${color}
  ${position}
`;

H2.displayName = 'H2';
export default H2;
